import * as Yup from 'yup';
import { styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

type ChildAgeValidationMessages = Readonly<{
  childAgeMin: string;
  childAgeMax: string;
  childAgeInvalid: string;
  childAgeRequired: string;
}>;

export type { ChildAgeValidationMessages };

const createChildrenAgesSchema = (validation: ChildAgeValidationMessages) =>
  Yup.array().of(
    Yup.number().nullable().typeError(validation.childAgeInvalid).required(validation.childAgeRequired).min(0, validation.childAgeMin).max(17, validation.childAgeMax),
  );

const createRoomSchema = (validation: ChildAgeValidationMessages) =>
  Yup.object({
    adults: Yup.number(),
    childrenAges: createChildrenAgesSchema(validation),
  });

export const createOccupancySchema = (validation: ChildAgeValidationMessages) => {
  const roomsSchema = Yup.array().of(createRoomSchema(validation));
  return roomsSchema.test('occupancy', 'Invalid occupancy', function (value) {
    if (!value) {
      return false;
    }
    return value.length > 0;
  });
};

export const AGE_OPTIONS = Array.from({ length: 18 }, (_, i) => i);

export const StyledAgeSelect = styled('select')`
  width: 100%;
  max-width: ${pxToRem(160)};
  height: ${pxToRem(40)};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  border: 1px solid ${({ theme }) => theme.colors.mono6};
  border-radius: ${pxToRem(8)};
  font-size: ${pxToRem(14)};
  font-family: inherit;
  background-color: white;
  cursor: pointer;
  outline: none;

  &:hover {
    border-color: ${({ theme }) => theme.colors.mono8};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.newUIBrandPrimary};
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.newUIBrandPrimary};
  }

  &[aria-invalid='true'] {
    border-color: ${({ theme }) => theme.colors.red6};
  }
`;
